<template>
  <div class="modal fade" v-bind:id="'addEditOrganizationModal' + AccountId">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="!editing" class="modal-title">
            New {{ OrganizationType ? OrganizationType.Title : "" }}
          </h5>
          <h5 v-if="editing" class="modal-title">Edit Organization</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <transition name="slide-fade" mode="out-in">
            <form v-if="page == 1" @submit.prevent="page = 2" key="name">
              <div class="form-group">
                <label for="name"
                  >{{
                    OrganizationType ? OrganizationType.Title : ""
                  }}
                  Name</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Name"
                  v-model="newOrgName"
                />
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-primary">
                  Next
                </button>
              </div>
            </form>

            <form
              v-if="page == 2"
              @submit.prevent="submitOrganization"
              key="permissions"
              class="text-left"
            >
              <label>{{ newOrgName }} Managers</label>
              <div
                v-for="user in users.slice().sort($orderByLastName)"
                :key="user.User_Id + 'subject'"
                class="form-group form-check"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-bind:id="user.User_Id"
                  v-bind:value="user.User_Id"
                  v-model="newSchoolGroupManagers"
                />
                <label class="form-check-label" v-bind:for="user.User_Id"
                  >{{ user.First_Name }} {{ user.Last_Name }}</label
                >
              </div>
              <div class="row">
                <div class="col-auto">
                  <button
                    type="button"
                    class="btn btn-primary"
                    v-on:click="page = 1"
                  >
                    Back
                  </button>
                </div>
                <div class="col" />
                <div class="col-auto">
                  <button v-if="!editing" type="submit" class="btn btn-primary">
                    Create Organization
                  </button>
                  <button v-if="editing" type="submit" class="btn btn-primary">
                    Update Organization
                  </button>
                </div>
              </div>
            </form>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "AddEditOrganizationModal",
  props: {
    OrganizationType: Object,
    ParentOrganizationId: String,
    AccountId: String,
    Organization: Object,
    Users: Array
  },
  data() {
    return {
      newOrgName: "",
      newOrgType: 0,
      newOrgParent: 0,
      editing: false,
      organizationToEdit: null,
      orgTypesToUse: [],
      users: [],
      page: 1,
      newSchoolGroupManagers: [],
      originalSchoolGroupManagers: []
    };
  },
  watch: {
    Organization: function() {
      if (this.Organization != null) {
        this.newOrgName = this.Organization.Name;
        this.newOrgType = this.Organization.Organization_Type;
        this.newOrgParent = this.Organization.Parent_Organization_Id;
        this.editing = true;
        var originalManagers = this.users
          .filter(u =>
            u.Permissions.some(
              p =>
                p.Permission_Id == 4 &&
                p.Organization_Id == this.Organization.Organization_Id
            )
          )
          .map(u => u.User_Id);
        this.newSchoolGroupManagers = originalManagers.slice();
        this.originalSchoolGroupManagers = originalManagers.slice();
      } else {
        this.editing = false;
        this.clearFields();
      }
    }
  },
  async mounted() {
    var view = this;
    this.users = await this.$queryUsers(null, [this.AccountId]);
    $("#addEditOrganizationModal" + this.AccountId).on(
      "hidden.bs.modal",
      function() {
        if (view.editing) {
          view.$emit("edit-closed");
        }
      }
    );
    $("#addEditOrganizationModal" + this.AccountId).on(
      "shown.bs.modal",
      function() {
        $("#name").focus();
      }
    );
  },
  methods: {
    async submitOrganization() {
      if (!this.editing) {
        await this.createOrganization();
      } else {
        await this.updateOrganization();
      }
    },
    async createOrganization() {
      $("#addEditOrganizationModal" + this.AccountId).modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var organizationToCreate = {
        Name: view.$data.newOrgName,
        Parent_Organization_Id: parseInt(view.ParentOrganizationId),
        Organization_Type: view.OrganizationType,
        Account_Id: parseInt(view.AccountId),
        Users: []
      };

      await this.$createOrganization(organizationToCreate)
        .then(async newOrg => {
          for (let i = 0; i < view.newSchoolGroupManagers.length; i++) {
            await view.$createSingleUserOrganizationPermission(
              view.newSchoolGroupManagers[i],
              newOrg.Organization_Id,
              4
            );
          }
          this.users = await this.$queryUsers(null, [this.AccountId]);
          await view.$loadUser(view.$store.getters.user.Cognito_Id);
          view.$store.commit("updateLoading", false);
          view.$emit("added-org", newOrg);
          this.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    async updateOrganization() {
      $("#addEditOrganizationModal" + this.AccountId).modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);

      var organizationToUpdate = view.Organization;
      organizationToUpdate.Name = view.newOrgName;
      organizationToUpdate.Parent_Organization_Id = parseInt(
        view.$data.newOrgParent
      );
      organizationToUpdate.Organization_Type = view.newOrgType;
      organizationToUpdate.Account_Id = parseInt(view.AccountId);

      await this.$updateOrganization(organizationToUpdate)
        .then(async updatedOrg => {
          var usersToAddPermissions = view.newSchoolGroupManagers.filter(
            m => !view.originalSchoolGroupManagers.includes(m)
          );
          var userIdsToRemovePermissions = view.originalSchoolGroupManagers.filter(
            m => !view.newSchoolGroupManagers.includes(m)
          );
          var usersToRemovePermissions = view.users.filter(u =>
            userIdsToRemovePermissions.includes(u.User_Id)
          );
          for (let i = 0; i < usersToAddPermissions.length; i++) {
            await view.$createSingleUserOrganizationPermission(
              usersToAddPermissions[i],
              updatedOrg.Organization_Id,
              4
            );
          }
          var userPermissionsToRemove = [];
          for (let i = 0; i < usersToRemovePermissions.length; i++) {
            userPermissionsToRemove.push(
              usersToRemovePermissions[i].Permissions.find(
                p =>
                  p.Permission_Id == 4 &&
                  p.Organization_Id == this.Organization.Organization_Id
              ).User_Permission_Id
            );
          }
          await view.$removeUserPermissions(userPermissionsToRemove);
          this.users = await this.$queryUsers(null, [this.AccountId]);
          await view.$loadUser(view.$store.getters.user.Cognito_Id);
          view.$store.commit("updateLoading", false);
          view.$emit("edited-org", updatedOrg);
          this.clearFields();
        })
        .catch(e => {
          console.log(e);
          view.$store.commit("updateLoading", false);
        });
    },
    clearFields() {
      this.newOrgName = "";
      if (this.orgTypesToUse[0]) {
        this.newOrgType = this.orgTypesToUse[0].Organization_Type_Id;
      } else {
        this.newOrgType = 0;
      }
      this.newOrgParent = 0;
      this.newSchoolGroupManagers = [];
      this.originalSchoolGroupManagers = [];
      this.page = 1;
    }
  }
};
</script>
